module.exports = __webpack_public_path__ + "static/media/gerd-image2@2x.9a606e05.png";